import styled from 'styled-components';
import { InputStyled } from '../InputStyled';

export const InputStyledAP = styled(InputStyled)``;
